/* eslint-disable @typescript-eslint/no-floating-promises */
// Package Imports
import { createContext, useContext, useEffect, useState } from 'react';

// Project Imports

import SocketEvent from 'core/constants/SocketEvent';
import { useTokenContext } from 'contexts/resource/ResourceContext';
import fetchNotificatons from 'core/utils/fetchNotifications';
import { SocketNotificationContextType } from 'contexts/socketNotificationContext/SocketNotificationContextType';
// import setNotificatonApi from 'core/utils/setNotificationApi';

const SocketNotificationContext = createContext<SocketNotificationContextType>({
  setNotificationMessages: () => {},
  notificationMessages: [],
  inputDataUpload: false,
  masterDataUpload: false,
  initiateUnification: false,
  calculateEvent: false,
  nudgeEvent: false,
  setInputDataUpload: () => {},
  setMasterDataUpload: () => {},
  setInitiateUnification: () => {},
  setCalculateEvent: () => {},
  setNudgeEvent: () => {},
  taskCreationProgress: false,
  setTaskCreationProgress: () => {},
  dataCorrectionEvent: false,
  setDataCorrectionEvent: () => {},
});

export function useSocketNotificationContext() {
  return useContext(SocketNotificationContext);
}

const SocketNotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { userDetails, socketInstance } = useTokenContext();
  const [inputDataUpload, setInputDataUpload] = useState(false); // input data upload
  const [masterDataUpload, setMasterDataUpload] = useState(false); // master data upload
  const [initiateUnification, setInitiateUnification] = useState(false); // initiate unification
  const [calculateEvent, setCalculateEvent] = useState(false); // start calculation
  const [nudgeEvent, setNudgeEvent] = useState(false); // start Nudge
  const [notificationMessages, setNotificationMessages] = useState<any>(() => {
    const notificationList = localStorage.getItem('notifications');
    return (notificationList && JSON.parse(notificationList)) || [];
  });
  const [taskCreationProgress, setTaskCreationProgress] = useState(false);
  const [dataCorrectionEvent, setDataCorrectionEvent] = useState(false);

  const toggleSocketNotificationsApi = (eventName) => {
    switch (eventName) {
      case SocketEvent.INPUT_SYNC_EVENT_NAME:
        setInputDataUpload((prev) => !prev);
        break;
      case SocketEvent.MASTER_SYNC_EVENT_NAME:
        setMasterDataUpload((prev) => !prev);
        break;
      case SocketEvent.INITIATE_UNIFICATION_EVENT_NAME:
        setInitiateUnification((prev) => !prev);
        break;
      case SocketEvent.START_CALCULATION_EVENT_NAME:
        setCalculateEvent((prev) => !prev);
        break;
      case SocketEvent.NUDGE_EVENT_NAME:
        setNudgeEvent((prev) => !prev);
        break;
      case SocketEvent.TASK_CREATION_PROGRESS:
        setTaskCreationProgress((prev) => !prev);
        break;
      case SocketEvent.COMPUTE_CORRECTION_DIFF_EVENT_NAME:
      case SocketEvent.CLEAN_DATA_DIFF_EVENT_NAME:
      case SocketEvent.EXECUTE_CORRECTION_EVENT_NAME:
      case SocketEvent.DATA_CORRECTION_RESET_EVENT_NAME:
        setDataCorrectionEvent((prev) => !prev);
        break;
      default:
        break;
    }
  };

  // const toggleSocketNotifications = (type) => {
  //   if (type === SocketEvent.INITIATE_UNIFICATION_EVENT_NAME) {
  //     setInitiateUnification((prev) => !prev);
  //   } else if (type === SocketEvent.START_CALCULATION_EVENT_NAME) {
  //     setCalculateEvent((prev) => !prev);
  //   }
  // };

  useEffect(() => {
    if (socketInstance && userDetails) {
      fetchNotificatons(
        setNotificationMessages,
        userDetails,
        socketInstance,
        toggleSocketNotificationsApi
        // toggleSocketNotifications
      );
      // call function to update event
      // setNotificatonApi(socketInstance, toggleSocketNotificationsApi);
    }
  }, [socketInstance]);

  return (
    <SocketNotificationContext.Provider
      value={{
        inputDataUpload,
        masterDataUpload,
        initiateUnification,
        calculateEvent,
        setInputDataUpload,
        setMasterDataUpload,
        setInitiateUnification,
        setCalculateEvent,
        notificationMessages,
        setNotificationMessages,
        nudgeEvent,
        setNudgeEvent,
        taskCreationProgress,
        setTaskCreationProgress,
        dataCorrectionEvent,
        setDataCorrectionEvent,
      }}
    >
      {children}
    </SocketNotificationContext.Provider>
  );
};

export default SocketNotificationProvider;
